import axios from 'axios';

// ======================== Configuration ========================
const BASE_URL = 'https://loyalty.bom.asia';

// ======================== Banner QLT Functions ========================

/**
 * Lấy tất cả Banner QLT
 */
export const fetchLoadingBannerQLT = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/api/imageQLT/banner`);
    return response.data.banners || [];
  } catch (error) {
    console.error('Error fetching banner:', error);
    throw error.response?.data || { message: 'Failed to fetch banner' };
  }
};

/**
 * Upload Banner QLT
 */
export const fetchUploadBannerQLT = async (file) => {
  try {
    const formData = new FormData();
    formData.append('url', file);

    const response = await axios.post(`${BASE_URL}/api/imageQLT/banner`, formData);
    return response.data.banner;
  } catch (error) {
    console.error('Error uploading banner:', error);
    throw error.response?.data || { message: 'Failed to upload banner' };
  }
};

/**
 * Sửa Banner QLT
 */
export const fetchEditBannerQLT = async (id, formData) => {
  try {
    const response = await axios.put(`${BASE_URL}/api/imageQLT/banner/${id}`, formData);
    return response.data.banner;
  } catch (error) {
    console.error('Error editing banner:', error);
    throw error.response?.data || { message: 'Failed to edit banner' };
  }
};

/**
 * Xóa Banner QLT
 */
export const fetchDeleteBannerQLT = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}/api/imageQLT/banner/${id}`);
    return { id, ...response.data };
  } catch (error) {
    console.error('Error deleting banner:', error);
    throw error.response?.data || { message: 'Failed to delete banner' };
  }
};

// ======================== Default Export ========================
export default {
  fetchLoadingBannerQLT,
  fetchUploadBannerQLT,
  fetchEditBannerQLT,
  fetchDeleteBannerQLT,
};

